//#region imports
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import { GuaranteeComponentModel } from 'src/app/module/guarantee/model/tarif.model';
import { ActivatedRoute } from '@angular/router';
import { DetailsService } from 'src/app/services/details.service';
import { DetailsComponentModel } from 'src/app/module/details/details.model';
import { AppConstants } from 'src/app/app.constants';
import { CharacteristicService } from 'src/app/services/characteristic.service';
import { CharacteristicsQuestionsSelected, CharacteristicsComponentModel } from
  'src/app/module/characteristics/components/characteristics.model';
import { SignatureComponentModel } from 'src/app/module/signature/model/signature.model';
import { SignatureService } from 'src/app/services/signature.service';
import { SummaryService } from 'src/app/services/summary.service';
import { RecapitulatoryComponentModel } from 'src/app/module/recapitulatory/model/recapitulatory.model';
import { P5xService } from 'src/app/services/p5x.service';
import { SectionService } from 'src/app/services/section.service';
import { SaveService } from 'src/app/services/save.service';
import { Globals } from 'src/app/services/globals';
import { DocumentService } from 'src/app/services/document.service';
//#endregion

@Component({
  selector: 'app-previous',
  templateUrl: './previous.component.html',
  styleUrls: ['./previous.component.css']
})
export class PreviousComponent implements OnInit {
  //#region variables
  currentSection;
  clientId;
  simulationTokenValue;
  language;
  characteristicsComponent: CharacteristicsComponentModel;
  detailsComponent: DetailsComponentModel;
  guaranteeComponent: GuaranteeComponentModel;
  recapitulatoryComponent: RecapitulatoryComponentModel;
  signatureComponent: SignatureComponentModel;
  characteristicChoiceSelected: boolean;
  characteristicQuestionsSelectedListStr: string;
  characteristicPreviousQuestionId: number;
  characteristicQuestionsSelectedListJSON: CharacteristicsQuestionsSelected[];
  characteristicsQuestionsSelectedListJSON: CharacteristicsQuestionsSelected[];
  characteristicsModelData: CharacteristicsComponentModel = {
    Question1: false, Question2: true, Question3: false, Question4: false, Question5: false
  };
  //#endregion

  //#region methods
  constructor(
    private location: Location, private sectionService: SectionService, private activatedRoute: ActivatedRoute,
    private characteristicService: CharacteristicService, private detailsService: DetailsService,
    private guaranteeService: GuaranteeService, private summaryService: SummaryService,
    private signatureService: SignatureService, private p5xService: P5xService, 
    private globals: Globals, private saveService: SaveService, 
    private documentService: DocumentService) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.clientId = params.clientId ? params.clientId : null;
      this.simulationTokenValue = params.simulationToken ? params.simulationToken : null;
      this.language = params.language ? params.language : AppConstants.Languages.DefaultLanguage;
    });
  }

  backClicked() {
    let sectionURl;
    const url = this.location.path();
    const index = url.indexOf('?');
    if (index !== -1) {
      sectionURl = url.substr(0, index);
    } else {
      sectionURl = url;
    }
    if (sectionURl === '') {
      this.characteristicsPreviousClick();
    } else if (sectionURl === '/characteristics') {
      this.characteristicsPreviousClick();
    } else if (sectionURl === '/details') {
      const section = this.detailsService.getDetailsSection();
      if (section === 'S2.1') {
        this.details2Point1PreviousClick();
      } else {
        this.details2Point2PreviousClick();
      }
    } else if (sectionURl === '/guarantee') {
      this.guaranteePreviousClick();
    } else if (sectionURl === '/recapitulatory') {
      this.recapitulatoryPreviousClick();
    } else if (sectionURl === '/signature') {
      this.signaturePreviousClick();
    }
  }

  characteristicsPreviousClick() {
    let previousQuestionData;
    if (this.characteristicService.getP1Screen()) {
      this.characteristicService.setShowLandingPage(true);
    } else {
      this.characteristicQuestionsSelectedListStr = sessionStorage.getItem(AppConstants.LocalStorage.CharacteristicQuestionsSelectedList);
      this.characteristicQuestionsSelectedListJSON = JSON.parse(this.characteristicQuestionsSelectedListStr);
      let groupKey = this.characteristicService.getCharacteristicGroupKey();
      const previousQuestionID = this.characteristicQuestionsSelectedListJSON.find(obj => obj.GroupKey === groupKey).previousQuestionId;
      if (previousQuestionID) {
        previousQuestionData = this.characteristicQuestionsSelectedListJSON.find(obj => obj.questionId === previousQuestionID);
        const previousGroupKey = previousQuestionData.GroupKey;
        // groupKey = previousGroupKey;
        this.characteristicService.setCharacteristicGroupKey(previousGroupKey);
      } else {
        groupKey = 'G1';
      }
      if (this.characteristicQuestionsSelectedListJSON) {
        if (groupKey === AppConstants.GroupConstants.Group1) {
          const clientIdPresent = this.sectionService.getClientIdPresent();
          if (clientIdPresent) {
            this.characteristicService.setShowPrevious(true);
          } else {
            this.characteristicService.setShowPrevious(false);
          }
          this.characteristicService.setCharacteristicCurrentPage(true, false, false, false, false);
        } else if (groupKey === AppConstants.GroupConstants.Group2) {
          this.characteristicService.setShowPrevious(true);
          this.characteristicService.setCharacteristicCurrentPage(false, true, false, false, false);
        } else if (groupKey === AppConstants.GroupConstants.Group3) {
          this.characteristicService.setShowPrevious(true);
          this.characteristicService.setCharacteristicCurrentPage(false, false, true, false, false);
        } else if (groupKey === AppConstants.GroupConstants.Group4) {
          this.characteristicService.setShowPrevious(true);
          this.characteristicService.setCharacteristicCurrentPage(false, false, false, true, false);
        } else if (groupKey === AppConstants.GroupConstants.Group5) {
          this.characteristicService.setShowPrevious(true);
          this.characteristicService.setCharacteristicCurrentPage(false, false, false, false, true);
        }
      }
    }
  }

  details2Point1PreviousClick() {
    this.detailsService.getDetailsComponent().subscribe((value) => {
      this.detailsComponent = value;
    });
    if (this.detailsComponent.DetailsQuestion1) {
      this.characteristicFromDetailsSection();
    } else if (this.detailsComponent.DetailsQuestion2) {
      this.detailsService.setDisableDetailsNext(false);
      this.detailsService.setDetailsCurrentPage(true, false, false, false, false, false,
        false, false, false, false, false, false);
    } else if (this.detailsComponent.DetailsQuestion3) {
      this.detailsService.setDisableDetailsNext(false);
      this.detailsService.setDetailsCurrentPage(false, true, false, false, false, false,
        false, false, false, false, false, false);
    } else if (this.detailsComponent.DetailsQuestion4) {
      this.detailsService.setDisableDetailsNext(false);
      this.detailsService.setDetailsCurrentPage(false, false, true, false, false, false,
        false, false, false, false, false, false);
    } else if (this.detailsComponent.DetailsQuestion5) {
      this.detailsService.setDisableDetailsNext(false);
      this.detailsService.setDetailsCurrentPage(false, false, false, true, false, false,
        false, false, false, false, false, false);
    } else if (this.detailsComponent.DetailsQuestion6) {
      this.detailsService.setDisableDetailsNext(false);
      this.detailsService.setDetailsCurrentPage(false, false, false, false, true, false,
        false, false, false, false, false, false);
    }
  }

  details2Point2PreviousClick() {
    this.detailsService.getDetailsComponent().subscribe((value) => {
      this.detailsComponent = value;
    });
    if (this.detailsComponent.DetailsQuestion7) {
      this.characteristicFromDetailsSection();
    } else if (this.detailsComponent.DetailsQuestion8) {
      this.detailsService.setDisableDetailsNext(false);
      this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
        true, false, false, false, false, false);
    } else if (this.detailsComponent.DetailsQuestion9) {
      this.detailsService.setDisableDetailsNext(false);
      this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
        false, true, false, false, false, false);
    } else if (this.detailsComponent.DetailsQuestion10) {
      this.detailsService.setDisableDetailsNext(false);
      this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
        false, false, true, false, false, false);
    } else if (this.detailsComponent.DetailsQuestion11) {
      this.detailsService.setDisableDetailsNext(false);
      this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
        false, false, false, true, false, false);
    } else if (this.detailsComponent.DetailsQuestion12) {
      this.detailsService.setDisableDetailsNext(false);
      this.detailsService.setDetailsCurrentPage(false, false, false, false, false, false,
        false, false, false, false, true, false);
    }
  }

  characteristicFromDetailsSection() {
    this.characteristicService.setCharacteristicChoiceSelected(false);
    const characteristicsQuestionsSelectedListStr = sessionStorage.getItem(AppConstants.LocalStorage.CharacteristicQuestionsSelectedList);
    this.characteristicsQuestionsSelectedListJSON = JSON.parse(characteristicsQuestionsSelectedListStr);
    const length = this.characteristicsQuestionsSelectedListJSON.length;
    const groupData = this.characteristicsQuestionsSelectedListJSON[length - 1];
    const previousQuestionID = groupData.previousQuestionId;
    const previousQuestionData = this.characteristicsQuestionsSelectedListJSON.find(obj => obj.questionId === previousQuestionID);
    const previousGroupKey = previousQuestionData.GroupKey;
    this.characteristicService.setCharacteristicGroupKey(previousGroupKey);
    const groupKey = groupData.GroupKey;
    if (groupKey === 'G1') {
      this.characteristicService.setShowPrevious(false);
      this.characteristicService.setCharacteristicCurrentPage(true, false, false, false, false);
    } else if (groupKey === 'G2') {
      this.characteristicService.setShowPrevious(true);
      this.characteristicService.setCharacteristicCurrentPage(false, true, false, false, false);
    } else if (groupKey === 'G3') {
      this.characteristicService.setShowPrevious(true);
      this.characteristicService.setCharacteristicCurrentPage(false, false, true, false, false);
    } else if (groupKey === 'G4') {
      this.characteristicService.setShowPrevious(true);
      this.characteristicService.setCharacteristicCurrentPage(false, false, false, true, false);
    } else if (groupKey === 'G5') {
      this.characteristicService.setShowPrevious(true);
      this.characteristicService.setCharacteristicCurrentPage(false, false, false, false, true);
    }
    if(this.globals.isMobile){
    this.characteristicService.setmobileCharacteristicProgressBarDetails();}
    this.sectionService.navigate('characteristics', this.clientId, this.simulationTokenValue, this.language);
    //this.characteristicService.setCharacteristicProgressBarDetails();
  }

  guaranteePreviousClick() {
    this.guaranteeService.getGuaranteeComponent().subscribe((value) => {
      this.guaranteeComponent = value;
    });
    if (this.guaranteeComponent.GuaranteeQuestion1) {
      const data = JSON.parse(sessionStorage.getItem('jsonData'));
      const section2Point1 = data.Sections.find(s => s.SectionKey === 'S2.1');      
      if (section2Point1) {        
        this.detailsService.setDetailsSectionFromGuarantee(true);
        this.detailsComponent = {
          DetailsQuestion1: false, DetailsQuestion2: false, DetailsQuestion3: false,
          DetailsQuestion4: false, DetailsQuestion5: false, DetailsQuestion6: true,
          DetailsQuestion7: false, DetailsQuestion8: false, DetailsQuestion9: false,
          DetailsQuestion10: false, DetailsQuestion11: false, DetailsQuestion12: false
        };
        this.detailsService.setDetailsComponent(this.detailsComponent);
        if(this.globals.isMobile)
        {this.detailsService.setmobileDetailsProgressBarDetails();}
        this.sectionService.navigate('details', this.clientId, this.simulationTokenValue, this.language);
        
      } else {
        this.detailsService.setDetailsSectionFromGuarantee(true);
        this.detailsComponent = {
          DetailsQuestion1: false, DetailsQuestion2: false, DetailsQuestion3: false,
          DetailsQuestion4: false, DetailsQuestion5: false, DetailsQuestion6: false,
          DetailsQuestion7: false, DetailsQuestion8: false, DetailsQuestion9: false,
          DetailsQuestion10: false, DetailsQuestion11: false, DetailsQuestion12: true
        };
        this.detailsService.setDetailsComponent(this.detailsComponent);
        if(this.globals.isMobile)
        {this.detailsService.setmobileDetailsProgressBarDetails();}
        this.sectionService.navigate('details', this.clientId, this.simulationTokenValue, this.language);
      }
    } else if (this.guaranteeComponent.GuaranteeQuestion2) {
      this.guaranteeService.setGuaranteeCurrentPage(true, false, false, false, false);
    } else if (this.guaranteeComponent.GuaranteeQuestion3) {
      const propertyDestinationRenting = this.guaranteeService.getPropertyDestinationRenting();
      if (propertyDestinationRenting) {
        this.guaranteeService.setGuaranteeCurrentPage(true, false, false, false, false);
      } else {
        this.guaranteeService.setGuaranteeCurrentPage(false, true, false, false, false);
      }
    } else if (this.guaranteeComponent.GuaranteeQuestion4) {
      this.guaranteeService.setGuaranteeCurrentPage(false, false, true, false, false);
    } else if (this.guaranteeComponent.GuaranteeQuestion5) {
      const propertyDestinationRenting = this.guaranteeService.getPropertyDestinationRenting();
      const contentCovering = this.guaranteeService.getContentCovering();
      const propTypeHouse = this.documentService.getIsHouse();
      const secondaryResidence = this.guaranteeService.getResidencePrinciple();
      const isOwner = this.p5xService.getIsOwner();
      if (propertyDestinationRenting) {
        this.guaranteeService.setGuaranteeCurrentPage(false, false, true, false, false);
      } else {
        if (contentCovering) {
          // tslint:disable-next-line: triple-equals
          // if(propertyDestinationRenting === false && isOwner === true && propTypeHouse === true && secondaryResidence === 'false' ){
          //   this.guaranteeService.setGuaranteeCurrentPage(false, false, true, false, false);
          // }
          // else {
          this.guaranteeService.setGuaranteeCurrentPage(false, false, false, true, false);
          // }
        } else {
          this.guaranteeService.setGuaranteeCurrentPage(false, false, true, false, false);
        }
      }
    }
  }

  recapitulatoryPreviousClick() {
    this.summaryService.getRecapitulatoryComponent().subscribe((value) => {
      this.recapitulatoryComponent = value;
    });
    if (this.recapitulatoryComponent.RecapitulatoryQuestion1) {
      this.guaranteeService.setGuaranteeCurrentPage(false, false, false, false, true);
      this.guaranteeService.setGuaranteeFromRecapitulatory(true);
      if(this.globals.isMobile)
      {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
      this.sectionService.navigate('guarantee', this.clientId, this.simulationTokenValue, this.language);
    } else {
      if (this.recapitulatoryComponent.RecapitulatoryQuestion2) {
        this.p5xService.setIsP5XPage(false);
        const isTakerOther = this.p5xService.getIsTakerOther();
        const isPropertyOther = this.p5xService.getIsPropertyOther();
        const p223IndoorPoolChecked = this.p5xService.getP223IndoorPoolChecked();
        const p215AcceptanceCriteriaChecked = this.p5xService.getP215AcceptanceCriteria();
        const p215GridCriteriaChecked = this.p5xService.getP215GridCriteriaChecked();
        const p225AcceptanceCriteriaChecked = this.p5xService.getP225AcceptanceCriteria();
        const p225GridCriteriaChecked = this.p5xService.getP225GridCriteriaChecked();
        const isOwner = this.p5xService.getIsOwner();
        const isSecondaryResidence = this.p5xService.getSecondaryResidence();
        const isTheftChecked = this.p5xService.getTheftChecked();
        const isP41TheftChecked = this.p5xService.getP41TheftChecked();
        const minPrem = this.guaranteeService.getMinimumPremium();
        const curpage = this.sectionService.getCurrentPage();
        let totprem;
        if (this.globals.totalPremium !== undefined && this.globals.totalPremium !== null){
        totprem = this.globals.totalPremium.replace(',', '.');}
        if (isPropertyOther) {
          this.characteristicService.setShowPrevious(false);
          this.characteristicService.setCharacteristicCurrentPage(false, false, true, false, false);
          this.characteristicService.setCharacteristicProgressBarDetails();

          const characteristicsQuestionsSelectedListStr = sessionStorage.getItem(AppConstants.LocalStorage.CharacteristicQuestionsSelectedList);
          this.characteristicsQuestionsSelectedListJSON = JSON.parse(characteristicsQuestionsSelectedListStr);
          const length = this.characteristicsQuestionsSelectedListJSON.length;
          const groupData = this.characteristicsQuestionsSelectedListJSON[length - 1];
          const previousQuestionID = groupData.previousQuestionId;
          const previousQuestionData = this.characteristicsQuestionsSelectedListJSON.find(obj => obj.questionId === previousQuestionID);
          const previousGroupKey = previousQuestionData.GroupKey;
          this.characteristicService.setCharacteristicGroupKey(previousGroupKey);

          // this.characteristicService.setCharacteristicGroupKey('G1');
          this.saveService.setSimulationStatus('Simulation in progress');
          if(this.globals.isMobile)
          {this.characteristicService.setmobileCharacteristicProgressBarDetails();}
          this.sectionService.navigate('characteristics', this.clientId, this.simulationTokenValue, this.language);
        } else if (isTakerOther) {
          this.characteristicService.setShowPrevious(false);
          this.characteristicService.setCharacteristicCurrentPage(true, false, false, false, false);
          this.characteristicService.setCharacteristicProgressBarDetails();
          this.saveService.setSimulationStatus('Simulation in progress');
          if(this.globals.isMobile)
          {this.characteristicService.setmobileCharacteristicProgressBarDetails();}
          this.sectionService.navigate('characteristics', this.clientId, this.simulationTokenValue, this.language);
        } else if (p215AcceptanceCriteriaChecked || p215GridCriteriaChecked) {
          this.detailsComponent = {
            DetailsQuestion1: false, DetailsQuestion2: false, DetailsQuestion3: false,
            DetailsQuestion4: false, DetailsQuestion5: true, DetailsQuestion6: false,
            DetailsQuestion7: false, DetailsQuestion8: false, DetailsQuestion9: false,
            DetailsQuestion10: false, DetailsQuestion11: false, DetailsQuestion12: false
          };
          this.detailsService.setDetailsComponent(this.detailsComponent);
          this.detailsService.setDetailsProgressBarDetails();
          this.saveService.setSimulationStatus('Simulation in progress');
          if(this.globals.isMobile)
          {this.detailsService.setmobileDetailsProgressBarDetails();}
          this.sectionService.navigate('details', this.clientId, this.simulationTokenValue, this.language);
        } else if (p223IndoorPoolChecked) {
          this.detailsComponent = {
            DetailsQuestion1: false, DetailsQuestion2: false, DetailsQuestion3: false,
            DetailsQuestion4: false, DetailsQuestion5: false, DetailsQuestion6: false,
            DetailsQuestion7: false, DetailsQuestion8: false, DetailsQuestion9: true,
            DetailsQuestion10: false, DetailsQuestion11: false, DetailsQuestion12: false
          };
          this.detailsService.setDetailsComponent(this.detailsComponent);
          this.detailsService.setDetailsProgressBarDetails();
          this.saveService.setSimulationStatus('Simulation in progress');
          if(this.globals.isMobile)
          {this.detailsService.setmobileDetailsProgressBarDetails();}
          this.sectionService.navigate('details', this.clientId, this.simulationTokenValue, this.language);
        } else if (p225AcceptanceCriteriaChecked || p225GridCriteriaChecked) {
          this.detailsComponent = {
            DetailsQuestion1: false, DetailsQuestion2: false, DetailsQuestion3: false,
            DetailsQuestion4: false, DetailsQuestion5: false, DetailsQuestion6: false,
            DetailsQuestion7: false, DetailsQuestion8: false, DetailsQuestion9: false,
            DetailsQuestion10: false, DetailsQuestion11: true, DetailsQuestion12: false
          };
          this.detailsService.setDetailsComponent(this.detailsComponent);
          this.detailsService.setDetailsProgressBarDetails();
          this.saveService.setSimulationStatus('Simulation in progress');
          if(this.globals.isMobile)
          {this.detailsService.setmobileDetailsProgressBarDetails();}
          this.sectionService.navigate('details', this.clientId, this.simulationTokenValue, this.language);
        } else if (this.p5xService.getP216CapitalGreaterThanMax()) {
          this.detailsComponent = {
            DetailsQuestion1: false, DetailsQuestion2: false, DetailsQuestion3: false,
            DetailsQuestion4: false, DetailsQuestion5: false, DetailsQuestion6: true,
            DetailsQuestion7: false, DetailsQuestion8: false, DetailsQuestion9: false,
            DetailsQuestion10: false, DetailsQuestion11: false, DetailsQuestion12: false
          };
          this.detailsService.setDetailsComponent(this.detailsComponent);
          this.detailsService.setDetailsProgressBarDetails();
          this.saveService.setSimulationStatus('Simulation in progress');
          if(this.globals.isMobile)
          {this.detailsService.setmobileDetailsProgressBarDetails();}
          this.sectionService.navigate('details', this.clientId, this.simulationTokenValue, this.language);
        } else if (this.p5xService.getP226CapitalGreaterThanMax()) {
          this.detailsComponent = {
            DetailsQuestion1: false, DetailsQuestion2: false, DetailsQuestion3: false,
            DetailsQuestion4: false, DetailsQuestion5: false, DetailsQuestion6: false,
            DetailsQuestion7: false, DetailsQuestion8: false, DetailsQuestion9: false,
            DetailsQuestion10: false, DetailsQuestion11: false, DetailsQuestion12: true
          };
          this.detailsService.setDetailsComponent(this.detailsComponent);
          this.detailsService.setDetailsProgressBarDetails();
          this.saveService.setSimulationStatus('Simulation in progress');
          if(this.globals.isMobile)
          {this.detailsService.setmobileDetailsProgressBarDetails();}
          this.sectionService.navigate('details', this.clientId, this.simulationTokenValue, this.language);
        } else if (this.p5xService.getContentCapital()) {
          this.guaranteeService.setGuaranteeProgressBarDetails();
          this.guaranteeService.setGuaranteeCurrentPage(false, true, false, false, false);
          this.guaranteeService.setGuaranteeFromRecapitulatory(true);
          this.saveService.setSimulationStatus('Simulation in progress');
          if(this.globals.isMobile)
          {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
          this.sectionService.navigate('guarantee', this.clientId, this.simulationTokenValue, this.language);
        } else if (this.globals.isTheftZero == true && curpage === 'P3-4') {
          this.guaranteeService.setGuaranteeProgressBarDetails();
          this.guaranteeService.setGuaranteeCurrentPage(false, false, false, true, false);
          this.guaranteeService.setGuaranteeFromRecapitulatory(true);
          this.guaranteeService.setPremiumTotalShow(true);
          this.saveService.setSimulationStatus('Simulation in progress');
          if(this.globals.isMobile)
          {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
          this.sectionService.navigate('guarantee', this.clientId, this.simulationTokenValue, this.language);
       } else if (isOwner && isSecondaryResidence && isTheftChecked) {
          this.guaranteeService.setGuaranteeProgressBarDetails();
          this.guaranteeService.setGuaranteeCurrentPage(false, false, false, true, false);
          this.guaranteeService.setGuaranteeFromRecapitulatory(true);
          this.saveService.setSimulationStatus('Simulation in progress');
          if(this.globals.isMobile)
          {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
          this.sectionService.navigate('guarantee', this.clientId, this.simulationTokenValue, this.language);
        } else if (Number(totprem) < Number(minPrem) && curpage === 'P3-4') {
          this.guaranteeService.setGuaranteeProgressBarDetails();
          this.guaranteeService.setGuaranteeCurrentPage(false, false, false, false, true);
          this.guaranteeService.setGuaranteeFromRecapitulatory(true);
          this.saveService.setSimulationStatus('Simulation in progress');
          if(this.globals.isMobile)
          {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
          this.sectionService.navigate('guarantee', this.clientId, this.simulationTokenValue, this.language);
        } else if (this.globals.isTheftZero && isP41TheftChecked && curpage === 'P4-1') {
          this.summaryService.setSummaryProgressBarDetails();
          if(this.globals.isMobile)
          {this.summaryService.setmobileSummaryProgressBarDetails();}
          this.saveService.setSimulationStatus('Simulation in Progress');
          this.summaryService.setRecapitulatoryCurrentPage(true, false);
          this.guaranteeService.setPremiumTotalShow(true);
        }else if (isOwner && isSecondaryResidence && isP41TheftChecked) {
          this.summaryService.setSummaryProgressBarDetails();
          if(this.globals.isMobile)
          {this.summaryService.setmobileSummaryProgressBarDetails();}
          this.saveService.setSimulationStatus('Simulation in Progress');
          this.summaryService.setRecapitulatoryCurrentPage(true, false);
        }else if (Number(totprem) < Number(minPrem) && curpage === 'P4-1') {
          this.summaryService.setSummaryProgressBarDetails();
          if(this.globals.isMobile)
          {this.summaryService.setmobileSummaryProgressBarDetails();}
          this.saveService.setSimulationStatus('Simulation in Progress');
          this.summaryService.setRecapitulatoryCurrentPage(true, false);
        } else if (this.p5xService.getRSRStatus()) {
          this.signatureService.setSignatureProgressBarDetails();
          this.signatureService.setShowSignaturePrevious(true);
          this.signatureService.setShowSignatureNext(true);
          this.saveService.setSimulationStatus('Simulation in Progress');
          this.signatureService.setSignatureCurrentPage(false, false, true, false, false, false, false, false);
          if(this.globals.isMobile)
          {this.signatureService.setmobileSignatureProgressBarDetails();}
          this.sectionService.navigate('signature', this.clientId, this.simulationTokenValue, this.language);
        } else if (this.signatureService.getAcceptanceCriteria() || this.signatureService.getP5XTxtBoxRequirement()) {
          this.signatureService.setSignatureProgressBarDetails();
          this.signatureService.setShowSignaturePrevious(true);
          this.signatureService.setShowSignatureNext(true);
          this.saveService.setSimulationStatus('Simulation in Progress');
          this.signatureService.setSignatureCurrentPage(false, false, false, true, false, false, false, false);
          if(this.globals.isMobile)
          {this.signatureService.setmobileSignatureProgressBarDetails();}
          this.sectionService.navigate('signature', this.clientId, this.simulationTokenValue, this.language);
        }else if (this.p5xService.getDocumentStatus()) {
        this.signatureService.setSignatureProgressBarDetails();
        this.signatureService.setShowSignaturePrevious(true);
        this.signatureService.setShowSignatureNext(true);
        this.saveService.setSimulationStatus('Simulation in Progress');
        this.signatureService.setSignatureCurrentPage(false, false, false, true, false, false, false, false);
        if(this.globals.isMobile)
        {this.signatureService.setmobileSignatureProgressBarDetails();}
        this.sectionService.navigate('signature', this.clientId, this.simulationTokenValue, this.language);
      }
      }
    }
  }

  signaturePreviousClick() {
    this.signatureService.getSignatureComponent().subscribe((value) => {
      this.signatureComponent = value;
    });
    if (this.signatureComponent.SignatureQuestion1) {
      this.summaryService.setRecapitulatoryCurrentPage(true, false);
      if(this.globals.isMobile)
      {this.summaryService.setmobileSummaryProgressBarDetails();}
      this.sectionService.navigate('recapitulatory', this.clientId, this.simulationTokenValue, this.language);
    } else if (this.signatureComponent.SignatureQuestion2) {
      this.signatureService.setShowSignaturePrevious(false);
      this.signatureService.setShowSignatureNext(true);
      this.signatureService.setSignatureCurrentPage(true, false, false, false, false, false, false, false);
    } else if (this.signatureComponent.SignatureQuestion3) {
      this.signatureService.setShowSignatureNext(true);
      this.signatureService.setSignatureCurrentPage(false, true, false, false, false, false, false, false);
    } else if (this.signatureComponent.SignatureQuestion4) {
      this.signatureService.setShowSignaturePrevious(true);
      this.signatureService.setShowSignatureNext(true);
      this.signatureService.setSignatureCurrentPage(false, false, true, false, false, false, false, false);
    } else if (this.signatureComponent.SignatureQuestion5) {
      this.signatureService.setShowSignaturePrevious(true);
      this.signatureService.setShowSignatureNext(true);
      this.signatureService.setSignatureCurrentPage(false, false, false, true, false, false, false, false);
    } else if (this.signatureComponent.SignatureQuestion6) {
      this.signatureService.setShowSignaturePrevious(false);
      this.signatureService.setShowSignatureNext(true);
      this.signatureService.setSignatureCurrentPage(false, false, false, false, true, false, false, false);
    } else if (this.signatureComponent.SignatureThanks) {
      this.signatureService.setShowSignaturePrevious(true);
      this.signatureService.setShowSignatureNext(true);
      this.signatureService.setSignatureCurrentPage(false, false, false, false, false, true, false, false);
    } else if (this.signatureComponent.SignatureRefuse) {
      this.signatureService.setShowSignaturePrevious(true);
      this.signatureService.setShowSignatureNext(true);
      this.signatureService.setSignatureCurrentPage(false, false, false, false, false, true, false, false);
    }
  }
  //#endregion
}
